export default {"src":"/_next/static/media/utk.96b15287.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};